import { render, staticRenderFns } from "./AppMultiFileDropzone.vue?vue&type=template&id=147f382a"
import script from "./AppMultiFileDropzone.vue?vue&type=script&lang=ts"
export * from "./AppMultiFileDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports